export const managingPatientsPageText = {
    pageLabelAndTitle: '등록 환자 관리',
    countDiagnosis: '명의 환자',
};

export const managingPatientsDiagnosisNothingLists = {
    text: '등록된 환자가 없습니다.',
    subText: '진료 추가를 통해 새로운 환자를 등록하고, 편리하게 관리해보세요.',
    buttonText: '진료 추가',
};

export const clManagingPatientsNothingLists = {
    text: '검색 결과가 없습니다.',
    subText: '작성하신 단어를 확인하고 다른 검색어로 검색해보세요.',
    buttonText: '새로고침',
};

export const clUserLookupNothingLists = {
    text: '조회된 사용자가 없습니다.',
    subText: '검색 조건을 확인하고 다시 조회해보세요.',
    buttonText: '새로고침',
};

export const clFavoritePatientsNothingLists = {
    text: '지정된 환자가 없습니다.',
    subText: '오늘 진료에 체크하여, 오늘 진료 환자로 지정해보세요!',
    buttonText: '오늘 진료 추가',
};

export const managingPatientsDiagnosisNothingSearchLists = {
    text: '검색 결과가 없습니다.',
    subText: '작성하신 단어를 확인하고 다른 검색어로 검색해보세요.',
    buttonText: '새로고침',
};
